package com.happyukrainian.revision.kweb.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.pages.routes.MaterialRoute
import com.happyukrainian.revision.kweb.components.PageContainer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.vh
import practicetest.MaterialsResponse
import repositories.HttpClientMaterialRepository

@Page("subject/{subject}/topic/{topic}/materials")
@Composable
fun MaterialPage() {
    val ctx = rememberPageContext()
    val subject = ctx.route.params.getValue("subject")
    val topic = ctx.route.params.getValue("topic")
    var materials by remember { mutableStateOf<MaterialsResponse?>(null) }
    LaunchedEffect(ctx) {
        HttpClientMaterialRepository().fetchMaterials(subject, topic).onSuccess {
            materials = it
        }
    }

    PageContainer(modifier = Modifier.minHeight(100.vh)) {
        MaterialRoute(materials, onFlashCardsSelected = {
            ctx.router.navigateTo("flashcards")
        })
    }
}